<template>
    <div>
        <h1 class="font-bold my-10">
            {{ $t('nav.about') }}
        </h1>
        <p v-html="about">
            
        </p>
    </div>
</template>

<script>
import api from '@/api';

export default {
    name: 'about',
    components: {
    },
    data(){
        return {
            loading: false,
            about: []
        }
    },
    methods: {
        async getAbout(){
            this.loading = true
            try{ 
                const response = await api.get('info/')
                this.about = response.data['about_us']
            }
            catch(e){
                console.log(e)
            }
            this.loading = false

        }
    },
    computed: {

    },
    async created(){
        await this.getAbout()
    }
}
</script>
